import React from "react";
import clsx from "clsx";
import { makeStyles, Typography } from "@material-ui/core";
import { ReactComponent as DownloadFileIcon } from "../../assets/svg/file.svg";

import { getFileSize } from "../../modules/academic/modals/helpers/helperFunctions";

export const useStyles = makeStyles(() => ({
  root: {
    minWidth: 320,
    minHeight: 39,
  },
  mainContainer: {
    border: "1px solid #dbdbdb",
    borderRadius: 12,
    textAlign: "center",
    backgroundColor: "#f5f6f7",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 20,

    "&+&": {
      borderTop: "1px solid #dbdbdb",
    },
  },
  iconInfoContainer: {
    display: "flex",
    alignItems: "center",
  },
  infoTextContainer: {
    textAlign: "left",
    marginLeft: 24,
    "&>p:first-child": {
      color: "#535358",
      fontSize: 14,
      fontWeight: "bold",

      whiteSpace: "nowrap",
      width: "240px",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    "&>p:nth-child(2)": {
      marginTop: -2,
      fontSize: 10,
      color: "#77838f",
    },
    "&>p:last-child": {
      marginTop: -2,
      fontSize: 10,
      color: "#77838f",
    },
  },
  icon: {
    width: 24,
    height: 32,
  },
}));

interface IFile {
  id?: string;
  name: string;
  size: number;
  path?: string;
}

interface IFileDownloadProps {
  file: IFile;
  needBorder?: boolean;
}

function DownloadFile({ file, needBorder = true }: IFileDownloadProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={clsx(needBorder && classes.mainContainer)}>
        <div className={classes.flexContainer}>
          <div className={classes.iconInfoContainer}>
            <DownloadFileIcon className={classes.icon} />
            <div className={classes.infoTextContainer}>
              <Typography>{file.name}</Typography>
              <Typography>File size: {getFileSize(file.size)}</Typography>
              <Typography>
                <a
                  href={file.path}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Download{" "}
                </a>
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DownloadFile);
